
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.277 25.88c-.067-.12-.483-1.069-2.483-3.021-2.094-2.044-1.813-1.712.71-5.247 1.536-2.152 2.15-3.467 1.957-4.029-.182-.536-1.312-.394-1.312-.394l-3.757.023s-.278-.04-.485.09c-.202.128-.332.424-.332.424s-.595 1.666-1.389 3.083c-1.674 2.989-2.344 3.146-2.617 2.96-.636-.431-.477-1.738-.477-2.665 0-2.897.417-4.104-.814-4.416-.41-.104-.71-.173-1.755-.185-1.34-.014-2.477.005-3.119.336-.428.22-.758.711-.556.74.248.034.81.159 1.11.586.385.55.371 1.79.371 1.79s.222 3.409-.517 3.833c-.508.29-1.203-.303-2.696-3.015-.764-1.389-1.342-2.925-1.342-2.925s-.11-.286-.31-.44a1.511 1.511 0 00-.577-.244l-3.573.023s-.536.016-.732.261c-.175.219-.014.669-.014.669s2.797 6.88 5.963 10.349c2.904 3.18 6.202 2.97 6.202 2.97h1.493s.452-.052.682-.313c.212-.24.204-.69.204-.69s-.03-2.108.902-2.419c.917-.306 2.095 2.038 3.344 2.94.944.682 1.661.532 1.661.532l3.34-.05s1.746-.113.918-1.557z","fill":"#E13131"}})])
          )
        }
      }
    